module.exports = "/templates/bds/public/images/7fc88777fc3ee282f4bda2ff4a6fff9a.svg";